<a class="award" *ngFor="let a of assignments" [uiParams]="{ badgeAssignmentId: a.id }" uiSref="gtmhub.badges._badge.badge">
  <ui-assignee [fromAssigneeId]="a.assignedById" [uiNameMultiline]="true" [uiNameEllipsis]="true" uiSize="sm"></ui-assignee>
  <i *ngIf="a.status !== 'REJECTED_ASSIGN'" ui-icon uiType="arrows-1_tail-right"></i>
  <i class="rejected" *ngIf="a.status === 'REJECTED_ASSIGN'" ui-icon uiType="ui-1_simple-remove"></i>
  <span>
    <ui-assignee *ngFor="let assigneeId of a.assigneeIds" [fromAssigneeId]="assigneeId" [uiNameMultiline]="true" [uiNameEllipsis]="true" uiSize="sm"></ui-assignee>
  </span>
</a>
